import { render, staticRenderFns } from "./BS_ParamSetting.vue?vue&type=template&id=2895277e&scoped=true&"
import script from "./BS_ParamSetting.vue?vue&type=script&lang=js&"
export * from "./BS_ParamSetting.vue?vue&type=script&lang=js&"
import style0 from "./BS_ParamSetting.vue?vue&type=style&index=0&id=2895277e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895277e",
  null
  
)

export default component.exports